import React from 'react';
import { useNavigate } from 'react-router-dom';

const SignupChoice = () => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: 'center', padding: '0px 20px 20px 20px' }}>
      <h2 style={{marginTop:'0px'}}>会員登録</h2>
      <div style={{ justifyContent:'center', marginTop: '0px', display:'flex', gap:'30px'}}>
        <a 
          onClick={() => navigate('/signup', { state: { gender: 'male' } })}
          style={{
            boxShadow: '0px 14px 14px -7px #276873',
            background:'linear-gradient(to bottom, #57c7f0 5%, #408c99 100%)',
            backgroundColor:'#57c7f0',
            display:'inline-block',
            cursor:'pointer',
            color:'#ffffff',
            fontSize:'20px',
            fontWeight:'bold',
            padding:'22px 45px',
            shadowtextsho:'0px 1px 13px #3d768a',
            
          }}
          onMouseEnter={(e) =>{e.target.style.background = 'linear-gradient(to bottom, #408c99 5%, #57c7f0 100%)', e.target.style.position = 'relative',e.target.style.top = '1px'}}
          onMouseLeave={(e) =>{e.target.style.background = 'linear-gradient(to bottom, #57c7f0 5%, #408c99 100%)', e.target.style.position = 'relative',e.target.style.top = '-1px'}}
          
        >
          男性登録
        </a>
        <a 
          onClick={() => navigate('/signup', { state: { gender: 'female' } })}
          style={{
            boxShadow: '0px 14px 14px -7px #722b36ff',
            background:'linear-gradient(to bottom, #fab3bfff 5%, #f85069ff 100%)',
            backgroundColor:'#fdb9c3ff',
            display:'inline-block',
            cursor:'pointer',
            color:'#ffffff',
            fontSize:'20px',
            border:'none',
            fontWeight:'bold',
            padding:'22px 45px',
            shadowtextsho:'0px 1px 13px #79202eff',
          }}
          onMouseEnter={(e) =>{e.target.style.background = 'linear-gradient(to bottom, #f85069ff 5%, #fab3bfff 100%)', e.target.style.position = 'relative',e.target.style.top = '1px'}}
          onMouseLeave={(e) =>{e.target.style.background = 'linear-gradient(to bottom, #fab3bfff 5%, #f85069ff 100%)', e.target.style.position = 'relative',e.target.style.top = '-1px'}}
          
        >
          女性登録
        </a>
      </div>
      
    </div >
  );
};

export default SignupChoice; 